import React, { Component, Fragment } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';

import SpinnerComponent from '../../../components/SpinnerComponent';
import IndietroButton from '../../../components/IndietroButton';
import StoricoAbbonamentiConsulente from './StoricoAbbonamentiConsulente';

import moment from 'moment';
import 'moment/locale/it';

const styles = {
  root: {
    height: '100%',
    padding: '26px 10px 26px 10px',
  },
  sectioncontainer: {
    border: '1px solid #e0e0e0',
    borderRadius: '6px',
    marginTop: '10px',
    marginBottom: '10px',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  userdatacontainer: {
    marginTop: '10px',
    marginBottom: '10px',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  textfield: {
    marginLeft: '20px',
    marginRight: '20px',
    marginBottom: '12px',
    width: '250px',
  },
  formLabel: {
    maxWidth: '460px',
  },
};

const getAuthLabel = (consulente) => {
  if (!consulente) return '';
  if (consulente.passwordEnabled) return 'Locale';
  if (consulente.oauthEnabled) return 'Microsoft SSO'; // per ora unico SSO
  return '-';
};

const dateTimeFormat = 'DD-MM-YYYY HH:mm';

export default class FormModificaConsulente extends Component {
  handleChange = (event) => {
    this.handleFormChange(event.target.name, event.target.value);
  };

  handleCheckboxValue = (event) => {
    this.handleFormChange(event.target.name, event.target.checked);
  };

  handleFormChange = (fieldName, value) => {
    this.props.onFormModified(fieldName, value);
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.props.onFormSubmitted();
  };

  render() {
    const disabledSubmitbutton =
      this.props.loading || !this.props.saveButtonEnabled;
    return (
      <Fragment>
        <CssBaseline />
        <Container style={styles.root}>
          {this.props.loading ? (
            <SpinnerComponent size={24} />
          ) : this.props.readFailed ? (
            <Typography
              variant="h6"
              style={{
                paddingTop: '6px',
                paddingBottom: '6px',
                color: this.props.theme.palette.error.main,
              }}
            >
              Impossibile caricare il consulente.
            </Typography>
          ) : this.props.notfound ? (
            <Typography
              variant="h6"
              style={{ paddingTop: '6px', paddingBottom: '6px' }}
            >
              Nessun record trovato
            </Typography>
          ) : (
            <form autoComplete="off" onSubmit={this.handleSubmit}>
              <Container style={{ maxWidth: '700px' }}>
                <Grid container justify="center" alignItems="center">
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={styles.sectioncontainer}
                  >
                    <Typography
                      variant="h5"
                      style={{ paddingTop: '6px', paddingBottom: '6px' }}
                    >
                      Dati registrazione utente
                    </Typography>
                    <Grid container style={styles.userdatacontainer}>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Grid
                          container
                          direction="column"
                          alignItems="center"
                          style={{ paddingBottom: '10px' }}
                        >
                          <TextField
                            id="consulente-id"
                            label="ID consulente"
                            disabled
                            defaultValue={
                              this.props.consulente.id === null
                                ? ''
                                : this.props.consulente.id
                            }
                            InputProps={{
                              readOnly: true,
                            }}
                            style={styles.textfield}
                          />
                          <TextField
                            id="consulente-email"
                            label="Email"
                            disabled
                            defaultValue={
                              this.props.consulente.email === null
                                ? ''
                                : this.props.consulente.email
                            }
                            InputProps={{
                              readOnly: true,
                            }}
                            style={styles.textfield}
                          />
                          <TextField
                            id="consulente-tipo-autenticazione"
                            label="Tipo autenticazione"
                            disabled
                            value={getAuthLabel(this.props.consulente)}
                            InputProps={{ readOnly: true }}
                            style={styles.textfield}
                          />
                          <TextField
                            id="consulente-data-registrazione"
                            label="Data registrazione"
                            disabled
                            defaultValue={
                              this.props.consulente.dataRegistrazione === null
                                ? ''
                                : moment(
                                    this.props.consulente.dataRegistrazione,
                                  ).format(dateTimeFormat)
                            }
                            InputProps={{
                              readOnly: true,
                            }}
                            style={styles.textfield}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Grid
                          container
                          direction="column"
                          alignItems="center"
                          style={{ paddingBottom: '10px' }}
                        >
                          {!this.props.superconsulenteView &&
                          !this.props.consulenteView ? (
                            <TextField
                              id="consulente-gruppo"
                              label="Gruppo di appartenenza"
                              disabled
                              value={this.props.nomeGruppo}
                              InputProps={{
                                readOnly: true,
                              }}
                              style={styles.textfield}
                            />
                          ) : null}
                          {this.props.superconsulenteView ||
                          this.props.consulenteView ? (
                            <TextField
                              id="consulente-superconsulente"
                              label="Superconsulente"
                              disabled
                              value={
                                this.props.consulente.superconsulente
                                  ? 'Sì'
                                  : 'No'
                              }
                              InputProps={{
                                readOnly: true,
                              }}
                              style={styles.textfield}
                            />
                          ) : null}
                          <TextField
                            id="consulente-registrazione-confermata"
                            label="Registrazione confermata"
                            name="validated"
                            disabled
                            value={
                              this.props.consulente.validated === true
                                ? 'Sì'
                                : 'No'
                            }
                            InputProps={{
                              readOnly: true,
                            }}
                            style={styles.textfield}
                          />
                          <TextField
                            id="consulente-privacy-policy"
                            label="Privacy policy accettata:"
                            disabled
                            defaultValue={
                              this.props.consulente.privacyPolicyAccettata
                                ? 'Si'
                                : 'No'
                            }
                            InputProps={{
                              readOnly: true,
                            }}
                            style={styles.textfield}
                          />
                          <TextField
                            id="consulente-termini-uso"
                            label="Termini d'uso accettati:"
                            disabled
                            defaultValue={
                              this.props.consulente.terminiUsoAccettati
                                ? 'Si'
                                : 'No'
                            }
                            InputProps={{
                              readOnly: true,
                            }}
                            style={styles.textfield}
                          />
                        </Grid>
                      </Grid>
                      {!this.props.superconsulenteView &&
                      !this.props.consulenteView ? (
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <FormControlLabel
                            style={styles.formLabel}
                            control={
                              <Checkbox
                                name="superconsulente"
                                // null until the consultant is read.
                                checked={
                                  !!this.props.consulente.superconsulente
                                }
                                onChange={this.handleCheckboxValue}
                                style={{
                                  color: this.props.theme.palette.primary.main,
                                  '&.MaterialUiChecked': {
                                    color:
                                      this.props.theme.palette.primary.main,
                                  },
                                }}
                              />
                            }
                            label="Selezionare la casella per assegnare il ruolo di superconsulente, deselezionarla per rimuovere il ruolo:"
                            labelPlacement="start"
                          />
                        </Grid>
                      ) : null}
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={styles.sectioncontainer}
                  >
                    <Typography
                      variant="h5"
                      style={{ paddingTop: '6px', paddingBottom: '6px' }}
                    >
                      Dati consulente
                    </Typography>
                    <Grid container style={styles.userdatacontainer}>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Grid container direction="column" alignItems="center">
                          <TextField
                            id="consulente-nome"
                            label="Nome"
                            value={
                              this.props.consulente.nome === null
                                ? ''
                                : this.props.consulente.nome
                            }
                            name="nome"
                            onChange={this.handleChange}
                            style={styles.textfield}
                          />
                          <TextField
                            id="consulente-cognome"
                            label="Cognome"
                            value={
                              this.props.consulente.cognome === null
                                ? ''
                                : this.props.consulente.cognome
                            }
                            name="cognome"
                            onChange={this.handleChange}
                            style={styles.textfield}
                          />
                          <TextField
                            id="consulente-telefono"
                            label="Telefono"
                            value={
                              this.props.consulente.telefono === null
                                ? ''
                                : this.props.consulente.telefono
                            }
                            name="telefono"
                            onChange={this.handleChange}
                            style={styles.textfield}
                          />
                        </Grid>
                      </Grid>

                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Grid container direction="column" alignItems="center">
                          <TextField
                            id="consulente-partita-iva"
                            label="Partita IVA"
                            value={
                              this.props.consulente.partitaIva === null
                                ? ''
                                : this.props.consulente.partitaIva
                            }
                            name="partitaIva"
                            onChange={this.handleChange}
                            style={styles.textfield}
                          />
                          <TextField
                            id="consulente-codice-sdi"
                            label="Codice SDI"
                            value={
                              this.props.consulente.codiceSdi === null
                                ? ''
                                : this.props.consulente.codiceSdi
                            }
                            name="codiceSdi"
                            onChange={this.handleChange}
                            style={styles.textfield}
                          />
                          <TextField
                            id="consulente-pec"
                            label="pec"
                            value={
                              this.props.consulente.pec === null
                                ? ''
                                : this.props.consulente.pec
                            }
                            name="pec"
                            onChange={this.handleChange}
                            style={styles.textfield}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {!this.props.gestitoDaPayments && (
                  <StoricoAbbonamentiConsulente
                    theme={this.props.theme}
                    abbonamenti={this.props.abbonamenti}
                    tipologiaPagamento={this.props.tipologiaPagamento}
                  />
                )}
                <Grid
                  container
                  justify="center"
                  style={{
                    paddingTop: '10px',
                    paddingBottom: '20px',
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{ textAlign: 'right' }}
                  >
                    <IndietroButton isDisabled={this.props.loading} />
                    <Button
                      type="button"
                      onClick={this.handleSubmit}
                      variant="contained"
                      size="medium"
                      disabled={disabledSubmitbutton}
                      style={{
                        color: disabledSubmitbutton
                          ? this.props.theme.palette.text.disabled
                          : this.props.theme.palette.text.main,
                        margin: '10px',
                        backgroundColor: disabledSubmitbutton
                          ? this.props.theme.palette.disabled.main
                          : this.props.theme.palette.primary.main,
                      }}
                    >
                      Salva modifiche
                    </Button>
                  </Grid>
                </Grid>
              </Container>
            </form>
          )}
        </Container>
      </Fragment>
    );
  }
}

FormModificaConsulente.propTypes = {
  theme: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  consulente: PropTypes.object,
  notfound: PropTypes.bool.isRequired,
  readFailed: PropTypes.bool,
  nomeGruppo: PropTypes.string.isRequired,
  abbonamenti: PropTypes.array.isRequired,
  tipologiaPagamento: PropTypes.string,
  gestitoDaPayments: PropTypes.bool,
  superconsulenteView: PropTypes.bool.isRequired,
  consulenteView: PropTypes.bool.isRequired,
  onFormModified: PropTypes.func.isRequired,
  onFormSubmitted: PropTypes.func.isRequired,
  saveButtonEnabled: PropTypes.bool.isRequired,
};
